import gql from 'graphql-tag';
import FragmentAppUser from 'graphql/fragments/app-user';

export default gql`
  query listApplications {
    listApplications {
      items {
        appId
        name
        uId
        createAt
        createByUser {
          ...FragmentAppUser
        }
      }
    }
  }

  ${FragmentAppUser}
`;
